<div class="home">
  <!-- <app-landing [user]="user"></app-landing> -->
  <new-landing-page [user]="user"></new-landing-page>
</div>
